
/* eslint-disable */
import React, { useRef, useEffect, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import Barcode from 'react-barcode';
import numeral from 'numeral';
import {
  faTag,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Dropdown
} from 'react-bootstrap';
import utils from '../../../utils/utils.functions';
import QRCode from "react-qr-code";


class ComponentToPrint extends React.Component {

  getExtGuide = (indexuBulto) => {
    const valueBulto = this.props.guide.bultos[indexuBulto].guia_externa;
    return (!valueBulto || valueBulto.trim() === '') ? '' : ` | EXT: ${valueBulto}`;
  }

  constructName = (name) => {
    const ptName = name.split(' ');
    let cName = '';
    ptName.map((item, index) => {
      if ((index + 1) % 2 !== 0) {
        cName += `${item} `;
      } else {
        cName += `${item[0]}.${index === ptName.legth + 1 ? '' : ' '}`;
      }
    })

    return cName;
  }

  render() {
    return (
      <>
    <div ref={this.props.propsRef}>
      {this.props.guide.bultos.map((elBultos, indexBul) => {
          return <React.Fragment key={indexBul}>
          <div style={{
            //border: "4px solid #000",
            width: 390,
            height: 428,
            padding: 10,
            margin: 2,
           }} className="printElement1">
          {/*indexBul >= 1 ? <div style={{ height: 13 }}></div> : null */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "4px dotted #000",
              height: 110
            }}
          >
            <div style={{ width: 110, height: "auto" }}>
              <img
                src={
                  this.props.empresa.logo_guia
                }
                style={{ width: "100%" }}
                alt="Logo"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end"
              }}
            >
              <div>
                <b style={{ fontSize: 22, fontWeight: "bold", color: 'black' }}>{this.props.empresa.nombre_empresa.toUpperCase()}</b>
              </div>
              <div style={{ fontSize: 18, fontWeight: "bold", color: 'black' }}>{this.props.empresa.rut_empresa}</div>
            </div>
          </div>

            
          {this.props.extra.emisorVisible &&
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 5,
                borderBottom: "4px dotted #000",
                flexDirection: "column",
              }}
            >

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingTop: 1,
              paddingBottom: 5,
              width: '100%',
            }}>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: 12, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>EMISOR</div>
                  <div style={{ fontSize: 13, fontWeight: "bold", color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>{this.constructName(this.props.guide.cliente.name.toUpperCase())}</div>
                </div>
                <div>
                  <div style={{  fontSize: 12,  color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>RUT</div>
                  <div style={{ fontSize: 15, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>{this.props.guide.cliente.rut.toUpperCase()}</div>
                </div>
              </div>
            </div>
         }

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 5,
              flexDirection: "column",
            }}
          >

          <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingTop: 2,
            paddingBottom: 2,
            width: '100%',
          }}>
            <div>
              <div style={{ fontWeight: "bold", fontSize: 12, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>DESTINATARIO</div>
              <div style={{ fontSize: 14, fontWeight: "bold", color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>{this.props.guide.cliente_receptor_nombre.toUpperCase()}</div>
            </div>
            <div>
              <div style={{ fontWeight: "bold", fontSize: 12, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600  }}>DNI</div>
              <div style={{ fontSize: 14, fontWeight: "bold", color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>{this.props.guide.cliente_receptor_identificacion}</div>
            </div>
          </div>

          <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: '100%',
          }}>
            <div>
              <div style={{ fontWeight: "bold", fontSize: 12, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>TELÉFONO</div>
              <div style={{ fontSize: 14, fontWeight: "bold",  color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>{this.props.guide.cliente_receptor_telefono.toUpperCase()}</div>
            </div>
          </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                paddingTop: 1,
                paddingBottom: 5
              }}
            >
              <div style={{ marginTop: 5, height: 80 }}>
                <div style={{ fontWeight: "bold", fontSize: 13, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600}}>DIRECCIÓN DE ENTREGA</div>
                <div style={{ fontSize: 14, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>
                  {this.props.guide.cliente_receptor_direccion_entrega.toUpperCase()} - {this.props.guide.estado_guia.estado !== '-' && this.props.guide.estado_guia.estado.toUpperCase()} {this.props.guide.ciudad_guia.ciudad !== '-' && this.props.guide.ciudad_guia.ciudad.toUpperCase()} {this.props.guide.pais_guia.country.toUpperCase()}
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 2,
              paddingTop: 2,
              paddingBottom: 2,
              height: 40,
              borderTop: "4px dotted #000",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                height: 30,
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 12, lineHeight: 1, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>REGISTRADO</div>
              <div style={{ fontSize: 16, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>{moment(this.props.guide.createdAt).format('DD/MM/YYYY')}</div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                height: 30,
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 12, lineHeight: 1, color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600  }}>PESO</div>
              <div style={{ textAlign: "center", width: "100%", fontSize: 16,  color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600 }}>
                {elBultos.peso} KG
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                height: 30,
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 12, lineHeight: 1, color: 'black',  fontFamily: 'Roboto Mono', fontWeight: 600  }}>FT3</div>
              <div style={{ textAlign: "center", width: "100%", fontSize: 16, color: 'black',  fontFamily: 'Roboto Mono', fontWeight: 600 }}>
                {elBultos.pie}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                height: 30,
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 12, lineHeight: 1 , color: 'black', fontFamily: 'Roboto Mono', fontWeight: 600  }}>BULTOS</div>
              <div style={{ textAlign: "center", width: "100%", fontSize: 16, fontWeight: "bold", color: 'black',  fontFamily: 'Roboto Mono', fontWeight: 600}}>
                {indexBul + 1} / {this.props.guide.bultos.length}
              </div>
            </div>
          </div>

          <div
            style={{
              borderBottom: "4px dotted #000",
              borderTop: "4px dotted #000",
              textAlign: 'center',
              paddingTop: 5,
              paddingBottom: 5,
              height: 80,
              marginBottom: 10,
            }}
          >
            <small style={{ fontWeight: 'bold', color: 'black' }}>Tipo de envio : <b>{this.props.guide.master_guia.rel_tipos.description.toUpperCase()}</b></small>
            {this.props.guide.estado_guia.estado !== '-' ? 
            <>
              <h1 style={{ margin: 0, fontSize: 23, lineHeight: 1, fontWeight: "bold", color: 'black'}}>{this.props.guide.estado_guia.estado.toUpperCase() }</h1>
              <small style={{ margin: 0, padding: 0, fontWeight: "bold", color: 'black', color: 'black' }}><b>{this.props.guide.ciudad_guia.ciudad.toUpperCase()}</b></small>
            </>
            : 
            <h1 style={{ margin: 0, fontSize: 23, lineHeight: 1, fontWeight: "bold", color: 'black' }}>{this.props.guide.pais_guia.country.toUpperCase() }</h1>
            }
          
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              marginTop: 2,
              paddingTop: 5,
              height: this.props.extra.emisorVisible ? 70 : 110,
            }}
          >
           {/* <Barcode displayValue={false} value={this.props.guide.uuid} height={50} width={1.0} margin={0} /> */}
            <div>
              <QRCode
                value={this.props.guide.uuid}
                size={60}
              />
            </div>
            <div>
               <div style={{ backgroundColor: 'black', padding: 10, borderRadius: 10, marginTop: 3}}>
                  <small style={{ fontWeight: 'bold', color: 'white' }}>NRO. GUÍA {this.getExtGuide(indexBul)}</small>
                  <h1 style={{ margin: 0, fontSize: 35, lineHeight: 1,  color: 'white'}}>{`${this.props.showPrefixGuide ? this.props.guide.master_guia.rel_tipos.prefijo : this.props.prefijo}-${this.props.guide.guia_paquete}`}</h1>
               </div>
            </div>
          </div>
          </div>
          <div style={{ breakAfter: 'page' }}></div>
          </React.Fragment>
      })}
    </div>
    </>
    );
  }
}
 
const PrinterGuideV5 = ({ data, prefijo, empresa, disabled, showPrefixGuide }) => {

  const extras = {
    emisorVisible: utils.configExtra(empresa.operaciones, 'SHOW_EMISOR_GUIDE'),
  };

  const [peso, setPeso] = useState(0);
  const [pie, setPie] = useState(0);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    bodyClass: "printElement1"
  });
  
  const calculatePeso = () => {
    let peso_total = 0;
    let pie_total = 0;
    data.bultos.forEach(e => {
      peso_total += parseFloat(e.peso);
      pie_total += parseFloat(e.pie);
    });
    let fPeso = numeral(peso_total).format('0.00')
    let fPie = numeral(pie_total).format('0.00')

    setPeso(fPeso);
    setPie(fPie);
  }

  useEffect(() => {
    calculatePeso()
  },[])

  return (
    <div>
      <div style={{ display: 'none'}}>
       <ComponentToPrint 
          guide={data}
          empresa={empresa}
          prefijo={prefijo}
          peso={peso}
          pie={pie}
          propsRef={componentRef}
          extra={extras}
          showPrefixGuide={showPrefixGuide}
        />
      </div>
      <Dropdown.Item disabled={disabled} onClick={handlePrint}>
        <FontAwesomeIcon icon={faTag} /> Imprimir guia
      </Dropdown.Item>
    </div>
  );
};

export default PrinterGuideV5;